import React, { useContext, useEffect, useState } from "react";
import "./styles.css";
import { Button } from "../Button";
import visaIcon from "../../../public/assets/visaIcon.svg";
import mstercardIcon from "../../../public/assets/mstercardIcon.svg";
import americanIcon from "../../../public/assets/americanIcon.svg";
import zelleIcon from "../../../public/assets/zelleIcon.svg";
import cardIcon from "../../../public/assets/icon/CardIcon.svg";
import { quoteContext } from "../../context/quotesContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";



const PaymentOptions = () => {
  const [t, i18n] = useTranslation();
  const [selectedPayment, setSelectedPayment] = useState("card");
  const navigate = useNavigate();
  const {
    setError,
    setLoading,
    createShipmentResponse,
    setCurrentSubStep,
  } = useContext(quoteContext);

  const handlePayment = async () => {
    setLoading(true);
    if(createShipmentResponse.stripe && selectedPayment === 'card'){
      window.location.href = createShipmentResponse.stripe;
    }
    if(createShipmentResponse.stripe && selectedPayment === 'zelle'){
      navigate(`/payment/status/success?consolidated_id=${createShipmentResponse.consolidated_id}&usa_address_id=${createShipmentResponse.usa_address_id}&co_address_id=${createShipmentResponse.co_address_id}&iszelle=true`);
    }
  }


  return (
    <div className="payment-container">
      <div className="payment-item">
        <input
          type="radio"
          id="card"
          name="payment"
          checked={selectedPayment === "card"}
          onChange={() => setSelectedPayment("card")}
        />
        <label htmlFor="card">
          <div className="payment-header">
            <span className="icon">
              <img className="cardImage" src={cardIcon} />
            </span>
            <span>{t('pay_with_credit_card')}</span>
            <div className="card-logos">
              <img src={visaIcon} alt="Visa" />
              <img src={mstercardIcon} alt="MasterCard" />
              <img src={americanIcon} alt="American Express" />
            </div>
          </div>
        </label>
      </div>
      <div className="payment-item">
        <input
          type="radio"
          id="zelle"
          name="payment"
          checked={selectedPayment === "zelle"}
          onChange={() => setSelectedPayment("zelle")}
        />
        <label htmlFor="zelle">
          <div className="payment-header">
            <img className="zelleImage" src={zelleIcon} alt="Zelle" />
            <span>{t('pay_with_zelle')}</span>
          </div>
        </label>
      </div>

      <div className="payment-options-btns">
        <a onClick={() => setCurrentSubStep(2)} className="link-blue">
          {t('return')}
        </a>
        <Button onClick={handlePayment}>
          {t('pay')}
        </Button>
      </div>
    </div>
  );
};

export default PaymentOptions;
